import BaseEnumType from "../../common/base-enum-type";

const BooleanType = Object.freeze({
    Yes: new BaseEnumType(true, "Yes"),
    No: new BaseEnumType(false, "No")
});

export default BooleanType;
